import type { Bounty, Submission, User } from "./types";

const BASE = "/api";

async function fetchJSON<T>(url: string, options?: RequestInit): Promise<T> {
	const res = await fetch(BASE + url, {
		headers: { "Content-Type": "application/json" },
		...options,
	});
	return res.json();
}

export const api = {
	getUsers: () => fetchJSON<User[]>("/users"),
	getUser: (id: string) => fetchJSON<User>(`/users/${id}`),

	getBounties: (status?: string) =>
		fetchJSON<Bounty[]>(status ? `/bounties?status=${status}` : "/bounties"),
	getBounty: (id: string) => fetchJSON<Bounty>(`/bounties/${id}`),
	createBounty: (data: Partial<Bounty>) =>
		fetchJSON<Bounty>("/bounties", { method: "POST", body: JSON.stringify(data) }),
	awardBounty: (bountyId: string, submissionId: string) =>
		fetchJSON<Bounty>(`/bounties/${bountyId}/award`, {
			method: "POST",
			body: JSON.stringify({ submissionId }),
		}),

	getSubmissions: (bountyId: string) =>
		fetchJSON<Submission[]>(`/bounties/${bountyId}/submissions`),
	createSubmission: (bountyId: string, data: Partial<Submission>) =>
		fetchJSON<Submission>(`/bounties/${bountyId}/submissions`, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	voteSubmission: (submissionId: string, userId: string) =>
		fetchJSON<Submission>(`/submissions/${submissionId}/vote`, {
			method: "POST",
			body: JSON.stringify({ userId }),
		}),
	forkSubmission: (submissionId: string, creatorId: string, bountyId: string) =>
		fetchJSON<Submission>(`/submissions/${submissionId}/fork`, {
			method: "POST",
			body: JSON.stringify({ creatorId, bountyId }),
		}),

	getRankings: () =>
		fetchJSON<{ user: User; rank: number; score: number }[]>("/rankings"),
};
